import styled from 'styled-components';
import palette from '@mlc/mlc-palette';
import { Col } from '@mlc/web-ui-toolkit';
import { ScreenSize } from '../../../enums';

export const SiteMenuLinks = styled.a`
	color: ${palette.mlcText};
	text-decoration: none;

	&:hover,
	&:focus {
		color: ${palette.mlcTextLink};
		text-decoration: underline;
	}
`;

export const SiteToolsLinks = styled.ul`
	display: flex;
	flex-grow: 1;
	height: 50px;
	line-height: 50px;
	list-style: none;
	margin: 0;
	padding: 0;
`;

export const SiteToolsLinkItem = styled.li`
	display: inline-block;
	margin: 0;
	padding-right: 20px;
	white-space: nowrap;
`;

export const SearchCol = styled(Col)`
	display: flex;
	justify-content: flex-end;

	@media (max-width: ${ScreenSize.xSmall}) {
		padding-right: 0;
		position: initial;
	}
`;
